export const ThemeName = {
    Primary: "primary",
    Success: "success",
    Neutral: "neutral",
    NeutralDark: "neutralDark",
    NeutralDarker: "neutralDarker",
    Danger: "danger",
    Warning: "warning",
    SuccessHighlight: "successHighlight",
} as const;

export type ThemeNameType = (typeof ThemeName)[keyof typeof ThemeName];
